import { Animated } from 'react-native'

import { styled } from '~/core/styled'

export const DropdownList = styled(Animated.View, theme => {
  return {
    base: {
      position: 'absolute',
      zIndex: theme.zindexOverlay,
    },
  }
})
